import BoxZoomIcon from '@apps-common/ui-icons/BoxZoom';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import MapPopperButton from './map-popper-button.jsx';

const BoxZoom = props => {
  const {t} = useTranslation();

  const {active, onClick} = props;

  return (
    <MapPopperButton
      tooltip={t('boxZoom.tooltip', 'Select an area to zoom to')}
      color={active ? 'primary' : undefined}
      onClick={onClick}
    >
      <BoxZoomIcon />
    </MapPopperButton>
  );
};

BoxZoom.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default BoxZoom;
